const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * Ghép URL hiển thị ảnh từ giá trị lưu trong DB.
 * Quy tắc (khớp App\Support\ImageStorage phía BE):
 *  - rỗng                 -> ""
 *  - đã là http(s)        -> giữ nguyên (dữ liệu cũ dạng URL tuyệt đối MinIO/local)
 *  - có tiền tố "storage/" -> `${API_URL}/${value}`      (dữ liệu cũ dạng "storage/...")
 *  - còn lại (path trần)   -> `${API_URL}/storage/${value}` (giá trị tương đối mới)
 *
 * @param {string|null|undefined} value giá trị ảnh lưu trong DB
 * @returns {string} URL hiển thị (rỗng nếu không có ảnh)
 */
export function resolveImageUrl(value) {
  if (!value) return "";
  const v = String(value).trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;

  const base = String(API_URL).replace(/\/+$/, "");
  const rel = v.replace(/^\/+/, "");
  const path = rel.startsWith("storage/") ? rel : `storage/${rel}`;
  return `${base}/${path}`;
}

export default resolveImageUrl;
